// extracted by mini-css-extract-plugin
module.exports = {"headline":"PortalFooter_headline__2qjrz","subhead":"PortalFooter_subhead__1Bjfr","cta":"PortalFooter_cta__26qNn"};